var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "share-options-overlay" }, [
    _c(
      "div",
      { staticClass: "share-options-form" },
      [
        _c("h2", [
          _vm._v(_vm._s(_vm.t("mail_roundcube_bridge", "Share options"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "share-options-form__file-info" }, [
          _c("img", {
            staticClass: "share-options-form__file-icon",
            attrs: { src: _vm.fileIconUrl, alt: _vm.fileName },
          }),
          _vm._v(" "),
          _c("span", { staticClass: "share-options-form__filename" }, [
            _vm._v(_vm._s(_vm.fileName)),
          ]),
        ]),
        _vm._v(" "),
        !_vm.configLoaded
          ? _c(
              "div",
              { staticClass: "share-options-form__loading" },
              [_c("NcLoadingIcon", { attrs: { size: 32 } })],
              1
            )
          : !_vm.sharingAllowed
          ? [
              _c("p", { staticClass: "share-options-form__error" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.t(
                        "mail_roundcube_bridge",
                        "Public link sharing is not available for your account."
                      )
                    ) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "share-options-form__actions" },
                [
                  _c(
                    "NcButton",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("cancel")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t("mail_roundcube_bridge", "Close")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          : [
              _c(
                "div",
                { staticClass: "share-options-form__field" },
                [
                  _c("NcTextField", {
                    attrs: {
                      value: _vm.label,
                      label: _vm.t("mail_roundcube_bridge", "Label"),
                      placeholder: _vm.t(
                        "mail_roundcube_bridge",
                        "e.g. recipient email"
                      ),
                    },
                    on: {
                      "update:value": function ($event) {
                        _vm.label = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "share-options-form__field" },
                [
                  _c(
                    "NcCheckboxRadioSwitch",
                    {
                      attrs: {
                        checked: _vm.passwordEnabled,
                        disabled: _vm.passwordEnforced,
                        type: "switch",
                      },
                      on: {
                        "update:checked": function ($event) {
                          _vm.passwordEnabled = $event
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.t(
                              "mail_roundcube_bridge",
                              "Protect with password"
                            )
                          ) +
                          "\n          "
                      ),
                      _vm.passwordEnforced
                        ? _c(
                            "span",
                            { staticClass: "share-options-form__enforced" },
                            [
                              _vm._v(
                                "\n            (" +
                                  _vm._s(
                                    _vm.t("mail_roundcube_bridge", "required")
                                  ) +
                                  ")\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.passwordEnabled
                    ? _c(
                        "div",
                        { staticClass: "share-options-form__password-row" },
                        [
                          _c("NcPasswordField", {
                            attrs: {
                              value: _vm.password,
                              label: _vm.t("mail_roundcube_bridge", "Password"),
                            },
                            on: {
                              "update:value": function ($event) {
                                _vm.password = $event
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "NcButton",
                            {
                              attrs: { type: "secondary" },
                              on: { click: _vm.generatePassword },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.t("mail_roundcube_bridge", "Generate")
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "share-options-form__field" },
                [
                  _c(
                    "NcCheckboxRadioSwitch",
                    {
                      attrs: {
                        checked: _vm.expiryEnabled,
                        disabled: _vm.expiryEnforced,
                        type: "switch",
                      },
                      on: {
                        "update:checked": function ($event) {
                          _vm.expiryEnabled = $event
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.expiryEnforced
                              ? _vm.t(
                                  "mail_roundcube_bridge",
                                  "Expiration date (enforced)"
                                )
                              : _vm.t(
                                  "mail_roundcube_bridge",
                                  "Set expiration date"
                                )
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.expiryEnabled
                    ? _c(
                        "div",
                        { staticClass: "share-options-form__expiry-row" },
                        [
                          _c(
                            "label",
                            {
                              staticClass: "share-options-form__expiry-label",
                              attrs: { for: "share-expiry-date" },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.t(
                                      "mail_roundcube_bridge",
                                      "Expiration date"
                                    )
                                  ) +
                                  "\n          "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.expiryDate,
                                expression: "expiryDate",
                              },
                            ],
                            staticClass: "share-options-form__date-input",
                            attrs: {
                              id: "share-expiry-date",
                              type: "date",
                              min: _vm.minDate,
                              max: _vm.maxDate,
                            },
                            domProps: { value: _vm.expiryDate },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.expiryDate = $event.target.value
                              },
                            },
                          }),
                          _vm._v(" "),
                          _vm.expiryError
                            ? _c(
                                "p",
                                { staticClass: "share-options-form__error" },
                                [
                                  _vm._v(
                                    "\n            " +
                                      _vm._s(_vm.expiryError) +
                                      "\n          "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "share-options-form__advanced-toggle" },
                [
                  _c(
                    "NcButton",
                    {
                      attrs: { type: "tertiary" },
                      on: {
                        click: function ($event) {
                          _vm.advancedOpen = !_vm.advancedOpen
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.t("mail_roundcube_bridge", "Advanced settings")
                          ) +
                          "\n          "
                      ),
                      _c("span", {
                        class: [
                          "share-options-form__caret",
                          {
                            "share-options-form__caret--open": _vm.advancedOpen,
                          },
                        ],
                      }),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm.advancedOpen
                ? _c("div", { staticClass: "share-options-form__advanced" }, [
                    _vm.allowViewWithoutDownload
                      ? _c(
                          "div",
                          { staticClass: "share-options-form__field" },
                          [
                            _c(
                              "NcCheckboxRadioSwitch",
                              {
                                attrs: {
                                  checked: _vm.hideDownload,
                                  type: "switch",
                                },
                                on: {
                                  "update:checked": function ($event) {
                                    _vm.hideDownload = $event
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.t(
                                        "mail_roundcube_bridge",
                                        "Hide download"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "share-options-form__field" },
                      [
                        _c(
                          "NcCheckboxRadioSwitch",
                          {
                            attrs: { checked: _vm.noteEnabled, type: "switch" },
                            on: {
                              "update:checked": function ($event) {
                                _vm.noteEnabled = $event
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.t(
                                    "mail_roundcube_bridge",
                                    "Note to recipient"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.noteEnabled
                          ? _c("NcTextArea", {
                              staticClass: "share-options-form__note",
                              attrs: {
                                value: _vm.note,
                                label: _vm.t(
                                  "mail_roundcube_bridge",
                                  "Note to recipient"
                                ),
                                placeholder: _vm.t(
                                  "mail_roundcube_bridge",
                                  "Enter a note for the share recipient"
                                ),
                              },
                              on: {
                                "update:value": function ($event) {
                                  _vm.note = $event
                                },
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.talkEnabled && _vm.passwordEnabled
                      ? _c(
                          "div",
                          { staticClass: "share-options-form__field" },
                          [
                            _c(
                              "NcCheckboxRadioSwitch",
                              {
                                attrs: {
                                  checked: _vm.sendPasswordByTalk,
                                  type: "switch",
                                },
                                on: {
                                  "update:checked": function ($event) {
                                    _vm.sendPasswordByTalk = $event
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.t(
                                        "mail_roundcube_bridge",
                                        "Video verification"
                                      )
                                    ) +
                                    "\n          "
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "share-options-form__field" },
                      [
                        _c(
                          "NcCheckboxRadioSwitch",
                          {
                            attrs: {
                              checked: _vm.customPermissions,
                              type: "switch",
                            },
                            on: {
                              "update:checked": function ($event) {
                                _vm.customPermissions = $event
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  _vm.t(
                                    "mail_roundcube_bridge",
                                    "Custom permissions"
                                  )
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.customPermissions
                          ? _c(
                              "div",
                              {
                                staticClass: "share-options-form__permissions",
                              },
                              [
                                _c(
                                  "NcCheckboxRadioSwitch",
                                  {
                                    attrs: {
                                      checked: true,
                                      disabled: true,
                                      type: "switch",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.t("mail_roundcube_bridge", "Read")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "NcCheckboxRadioSwitch",
                                  {
                                    attrs: {
                                      checked: _vm.permRead,
                                      type: "switch",
                                    },
                                    on: {
                                      "update:checked": function ($event) {
                                        _vm.permRead = $event
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.t("mail_roundcube_bridge", "Edit")
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "NcCheckboxRadioSwitch",
                                  {
                                    attrs: {
                                      checked: _vm.permDelete,
                                      type: "switch",
                                    },
                                    on: {
                                      "update:checked": function ($event) {
                                        _vm.permDelete = $event
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.t(
                                            "mail_roundcube_bridge",
                                            "Delete"
                                          )
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.serverError
                ? _c(
                    "div",
                    { staticClass: "share-options-form__server-error" },
                    [
                      _c(
                        "p",
                        {
                          staticClass:
                            "share-options-form__server-error-message",
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(
                                _vm.t(
                                  "mail_roundcube_bridge",
                                  "An error occurred while creating the share link. Please check your settings and try again."
                                )
                              ) +
                              "\n        "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _vm.serverErrorDetail
                        ? _c(
                            "details",
                            {
                              staticClass:
                                "share-options-form__server-error-details",
                            },
                            [
                              _c("summary", [
                                _vm._v(
                                  _vm._s(
                                    _vm.t(
                                      "mail_roundcube_bridge",
                                      "Technical details"
                                    )
                                  )
                                ),
                              ]),
                              _vm._v(" "),
                              _c("pre", [
                                _vm._v(_vm._s(_vm.serverErrorDetail)),
                              ]),
                            ]
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "share-options-form__actions" },
                [
                  _c(
                    "NcButton",
                    {
                      attrs: { type: "tertiary" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("cancel")
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.t("mail_roundcube_bridge", "Cancel")) +
                          "\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "NcButton",
                    { attrs: { type: "primary" }, on: { click: _vm.onSubmit } },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.t("mail_roundcube_bridge", "Create share link")
                          ) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }